
import '../../src/sass/style.scss';
import {addClass, removeClass, getIndexInArray, isMobile}  from './helper.js';
import {setHeader, scrollHeader, addDescription, addImprint, addFilter, addPreviewItems, addQuestionsToCanvas, addHintsToCanvas, addMobileQuestionsToCanvas}  from './dom.js';
import {Modal}  from './modal.js';
import {Accordion}  from './accordion.js';
import {Sidebar}  from './sidebar.js';
import {Sketch}  from './sketch.js';
import {Swipe}  from './swipe.js';


class App {
    constructor(data){
        this.options = data[0];
        this.items = data[1];
        this.el = {
            previewFigure: document.getElementsByClassName('js-preview-btn'),
            filterBtn: document.getElementsByClassName('js-filter-btn'),
            animateOnLoad: document.getElementsByClassName('js-animate-on-load'),
            sidebar: document.getElementsByClassName('js-sidebar'),
        }
        this.objects = {
            activeCategories: [],
            categories: [],
            items: [],
            index_description: null,
            imprint_description: null
        }

        this.score = {
            score: 0,
            lastID: -1,
            attempt: {},
        }

        this.createObject();
        this.createDom();

        
        this.modalCanvas= new Modal(document.getElementsByClassName('js-modal')[0]);
        this.modalImprint = new Modal(document.getElementsByClassName('js-modal')[1]);
        this.sketch = new Sketch();
        this.swipe = new Swipe();
        
        this.initEvents();
        
        // Sketch
        console.log(this.objects);   
        
    }
    createObject(){
        
        if(this.options.acf.hasOwnProperty('index_description')){
            this.objects.index_description = this.options.acf.index_description;
        }
        if(this.options.acf.hasOwnProperty('imprint_description')){
            this.objects.imprint_description = this.options.acf.imprint_description;
        }
        let categories = [];
        for (let i = 0; i < this.items.length; i++) {
            
            let item = {
                id: this.items[i].acf.object_id,
                title: this.items[i].acf.object_name,
                categorie: this.items[i].categories,
                thumb: this.items[i].thumbObj,
                glb: this.items[i].acf.object_file,
                glbmobile: this.items[i].acf.object_file_mobile,
                questions: [],
                hints: this.items[i].acf.object_hints,
            };
            categories.push(this.items[i].categories);
            this.objects.items.push(item);     
            
            // Add Questions
            if(this.items[i].acf.object_questions){
                
                for (let j = 0; j < this.items[i].acf.object_questions.length; j++) {

                    const q = this.items[i].acf.object_questions[j];
                    // Question Object
                    let question = {
                        question: q.object_questions_question,
                        answers: q.answer_options
                    };

                    item.questions.push(question);
                }
            }

            // Add Categories to Object
            this.objects.categories = categories;

            // Create Score ITEM
            this.score[this.items[i].acf.object_id] = [];
            this.score.attempt[this.items[i].acf.object_id] = [];
            
        }


        
    }
    createDom(){
        // Set the header
        
        setHeader();
        // Add the Project Desciption
        addDescription(this.objects.index_description);
        // Add Imprint
        addImprint(this.objects.imprint_description);
        // Add the Filter
        addFilter(this.objects.items, this.objects.categories);
        // Add Preview Items
        addPreviewItems(this.objects.items);
    }
    animateOnLoad(){
        if(this.el.animateOnLoad.length > 0){
            for (let i = 0; i < this.el.animateOnLoad.length; i++) {
                addClass(this.el.animateOnLoad[i], 'js-animate-on-load--loaded');
            }
        }
    }
    initEvents(){
        var that = this;
        window.addEventListener('scroll', scrollHeader);
    
        // Open Modal with Game Canvas
        for (let i = 0; i < this.el.previewFigure.length; i++) {
            this.el.previewFigure[i].addEventListener('click', this.openGameCanvas.bind(this));
        }

        for (let j = 0; j < this.el.filterBtn.length; j++) {
            this.el.filterBtn[j].addEventListener('click', this.filterItems.bind(this));
        }
    }
    openGameCanvas(event){
        const that = this;
        const target = event.target.closest('.js-preview-btn');
        // Add Object to Canvas
        this.sketch.addObjectToCanvas(this.objects.items, target.getAttribute('id'));

                    
        if(!isMobile()){
            // Add Questions to Canvas
            addQuestionsToCanvas(this.objects.items, this.score, target.getAttribute('id'));
            // Init Accordion
            new Accordion(document.getElementsByClassName('js-accordion')[0]);

        } else {
            // Add Mobile Questions Accordion
            
            addMobileQuestionsToCanvas(this.objects.items, this.score, target.getAttribute('id'));
        }

        // // Add Hints to Canvas
        addHintsToCanvas(this.objects.items, target.getAttribute('id'));

    }
    filterItems(event){
        const target = event.target.closest('.js-filter-btn');
        const filterID = target.getAttribute('data-filter-id');
        const index = getIndexInArray(this.objects.activeCategories, filterID);
        if(index == -1){
            // Add Filter
            this.objects.activeCategories.push(filterID);
            addClass(target, 'active-filter-btn');
        } else {
            // Remove Filter
            this.objects.activeCategories.splice(index, 1);
            removeClass(target, 'active-filter-btn');
        }
        // Filter Items
        for (let i = 0; i < this.objects.items.length; i++) {
            if(getIndexInArray(this.objects.activeCategories, this.objects.items[i].categorie.toLowerCase()) == -1){
                removeClass(document.getElementById(this.objects.items[i].id), 'filtered-preview-item');
            } else {
                addClass(document.getElementById(this.objects.items[i].id), 'filtered-preview-item');
            }
        }
    }



}
// 
// First Preload Data 
// 
const getOptionsData = new Promise((resolve, reject) => {
    fetch( window.location.href+'/wp-json/acf/v2/options/' )
    .then( response => response.json() )
    .catch(error => {console.log(error);})
    .then( response => {
        resolve(response);
    } );
});
const getItemData = new Promise((resolve, reject) => {
    fetch( window.location.href+'/wp-json/wp/v2/object/' )
    .then( response => response.json() )
    .catch(error => {console.log(error);})
    .then( response => {
        resolve(response);
    } );
});

// 
// Init APP
// 
Promise.all([getOptionsData, getItemData]).then((data) => {

    // // Init App and create Data OBJ
    const app = new App(data);
    
    var sidebar = document.getElementsByClassName('js-sidebar');
    if( sidebar.length > 0 ) {
      for( var i = 0; i < sidebar.length; i++) {
        (function(i){new Sidebar(sidebar[i]);})(i);
      }
      // switch from mobile to static layout
      var customEvent = new CustomEvent('update-sidebar');
      window.addEventListener('resize', function(event){
        (!window.requestAnimationFrame) ? setTimeout(function(){resetLayout();}, 250) : window.requestAnimationFrame(resetLayout);
      });
  
      (window.requestAnimationFrame) // init sidebar layout
        ? window.requestAnimationFrame(resetLayout)
        : resetLayout();
  
      function resetLayout() {
        for( var i = 0; i < sidebar.length; i++) {
          (function(i){sidebar[i].dispatchEvent(customEvent)})(i);
        };
      };
    }

    setTimeout(() => {
        app.animateOnLoad();
        removeClass(document.body, 'loading');
    }, 500);



});